<ng-container [ngTemplateOutlet]="cardTemplateData ? dataView.doesNotExist ? DoesNotExist : CardContent : NoData"></ng-container>

<ng-template #CardContent>

  <!-- DRILL AROUND ICON -->
  <ng-container *ngIf="listSpec.drillAroundMode">
    <div class="lm-list-card-drill-button-wrapper">
      <div class="lm-list-card-drill-button-container">
        <button soho-button="icon"
            id="drill_button"
            data-automation-id="lm-drill-around-button"
            soho-tooltip content="{{ 'Drill' | translate }}"
            attr.row-index="{{this.rowIndex}}"
            [icon]="'arrow-right'"
            (click)="onDrillClicked($event)"
        >
        </button>
      </div>
    </div>
  </ng-container>

  <div class="lm-card-view-wrapper">
    <!-- CARD CONTENT   -->
    <div class="lm-card-view" [attr.data-automation-id]="automationId">
      <!-- Card has image -->
      <div *ngIf="cardTemplateData?.image?.imageUrl" class="{{cardTemplateData?.image?.cardImageClasses}}">
            <!-- Standard image without "link is" -->
            <img *ngIf="!cardTemplateData?.image?.displayAsNavigation && !cardTemplateData?.image?.displayAsLink" class="avatar large" [src]="cardTemplateData?.image?.imageUrl" alt=""/>

            <!-- Image with "link is" with navigation params -->
            <a *ngIf="cardTemplateData?.image?.displayAsNavigation" href="javascript:void(0)" (click)="navigate(null, cardTemplateData?.image.navigationParams)" attr.data-automation-id="{{cardTemplateData?.automationId}}-image">
                <img class="avatar large" [src]="cardTemplateData?.image.imageUrl" alt=""/>
            </a>

            <!-- Image with "link is" with httpUrl (can navigate internally or externally) -->
            <a *ngIf="cardTemplateData?.image?.displayAsLink" (click)="openLink(cardTemplateData?.image.href, cardTemplateData?.image?.openExternal)" attr.data-automation-id="{{cardTemplateData?.automationId}}-image">
                <img class="avatar large" [src]="cardTemplateData?.image.imageUrl" alt=""/>
            </a>
        </div>

      <!-- Card does not have image and is using random avatars for missing image -->
      <div *ngIf="!cardTemplateData?.image.imageUrl && cardTemplateData?.image.isMissingImage && cardTemplateData?.image.isRandomBackground" class="{{cardTemplateData?.image?.cardImageClasses}}">
          <ng-container *ngIf="cardTemplateData?.image?.displayAsNavigation || cardTemplateData?.image?.displayAsLink; else NotActionable">
              <a *ngIf="cardTemplateData?.image?.displayAsNavigation" href="javascript:void(0)" (click)="navigate(null, cardTemplateData?.image.navigationParams)" attr.data-automation-id="{{cardTemplateData?.automationId}}-image">
                  <span class="{{cardTemplateData?.image?.bgColorClass}}">{{cardTemplateData?.image?.imageForegroundText}}</span>
              </a>
              <a *ngIf="cardTemplateData?.image?.displayAsLink" (click)="openLink(cardTemplateData?.image.href, cardTemplateData?.image?.openExternal)" attr.data-automation-id="{{cardTemplateData?.automationId}}-image">
                  <span class="{{cardTemplateData?.image?.bgColorClass}}">{{cardTemplateData?.image?.imageForegroundText}}</span>
              </a>
          </ng-container>
          <ng-template #NotActionable>
              <span class="{{cardTemplateData?.image?.bgColorClass}}">{{cardTemplateData?.image?.imageForegroundText}}</span>
          </ng-template>
      </div>

      <div class="lm-card-content">
        <div #FlexContainer class="lm-card-flex">
          <ng-container *ngFor="let cols of cardTemplateData.columns; let x = index;">
            <ng-container>
              <div #CardColumn [ngClass]="{'lm-column': true}" class="lm-align-{{cols.align}}">
                <div *ngFor="let item of cols.column; let i = index;" class="lm-card-row" [ngClass]="{'lm-hyperlink-container': (item.isExternalNavigation || item.isInternalNavigation) && !(boldFirstRow && i === 0)}">
                  <label *ngIf="item.label" lm-text-style [textStyle]="item?.textStyle" class="lm-card-label">{{item.label}}:</label>
                  <ng-container *ngIf="!item.alertCondition">

                    <ng-container *ngIf="!item.displayAsTag && !item.displayAsRating">
                      <a *ngIf="item.isExternalNavigation" href="{{item?.httpUrl}}" class="lm-card-field hyperlink" [target]="item.openExternal ? '_blank' : ''" lm-field-style [fieldStyle]="item?.fieldStyle" soho-tooltip [title]="item?.displayValue">{{item?.displayValue}}</a>
                      <a *ngIf="item.isInternalNavigation" href="javascript:void(0)" class="lm-card-field hyperlink" (click)="navigate(item)" lm-field-style [fieldStyle]="item?.fieldStyle" soho-tooltip [title]="item?.displayValue">{{item?.displayValue}}</a>
                    </ng-container>

                    <!-- display as tag -->
                    <div *ngIf="item.displayAsTag" class="lm-card-tag-container">

                      <span *ngIf="item.isField"
                        class="tag"
                        [style.color]="!!item?.fieldStyle?.color ? 'white' : null"
                        lm-field-style [fieldStyle]="item?.fieldStyle" [isTag]="true"
                      >{{item?.displayValue}}</span>

                      <a *ngIf="item.isExternalNavigation"
                         href="{{item?.httpUrl}}"
                         [target]="item.openExternal ? '_blank' : ''"

                         class="lm-card-field tag is-clickable"
                         [style.color]="!!item?.fieldStyle?.color ? 'white' : null"
                         lm-field-style [fieldStyle]="item?.fieldStyle" [isTag]="true"
                      >
                        <span>{{item?.displayValue}}</span>
                        <span>
                          <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                            <use xlink:href="#icon-caret-right"></use>
                          </svg>
                          <span class="audible"></span>
                        </span>
                      </a>

                      <a *ngIf="item.isInternalNavigation"
                         href="javascript:void(0)"
                         (click)="navigate(item)"

                         class="lm-card-field tag is-clickable"
                         [style.color]="!!item?.fieldStyle?.color ? 'white' : null"
                         lm-field-style [fieldStyle]="item?.fieldStyle" [isTag]="true"
                      >
                        <span>{{item?.displayValue.trim()}}</span>
                        <span>
                          <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                            <use xlink:href="#icon-caret-right"></use>
                          </svg>
                          <span class="audible"></span>
                        </span>
                      </a>
                    </div>

                    <!-- display as rating -->
                    <ng-container *ngIf="item.displayAsRating">
                      <div soho-rating class="lm-card-field is-readonly" [style.padding-top]="'3px'">
                        <fieldset>
                          <!--        <legend class="audible">Rate Your Experience</legend>-->
                          <ng-container *ngFor="let option of item.ratingOptions; index as i">
                            <input
                              type="radio"
                              [ngClass]="option.class"
                              name="rating_options"
                              id="{{option.id}}"
                              [attr.disabled]="true">
                            <label for="{{option.id}}" class="lm-card-label">
                              <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                                <use [attr.xlink:href]="option.href"></use>
                              </svg>
                              <span class="audible">{{option.label}}</span>
                            </label>
                          </ng-container>
                        </fieldset>
                      </div>
                    </ng-container>

                  <!-- is field  -->
                  <span *ngIf="item.isField && !item.isFormText && !item.displayAsTag && !item.isRichText && !item.displayAsRating"
                        class="lm-card-field"
                        lm-field-style [fieldStyle]="item?.fieldStyle"
                        soho-tooltip [content]="item.displayValue" [placement]="'bottom'" [delay]="1000"
                        [ngStyle]="{'-webkit-line-clamp' : item.lines }"
                  >{{item?.displayValue}}</span>

                  <!-- is form text-->
                  <span *ngIf="item.isFormText && !item.displayAsTag && !item.isRichText && !item.displayAsRating && !(item.isExternalNavigation || item.isInternalNavigation)"
                        [ngStyle]="{'-webkit-line-clamp' : item.lines }"
                        soho-tooltip [content]="item.displayValue" [placement]="'bottom'" [delay]="1000"
                        class="lm-card-field {{item?.displayAsAlert?.color}}"
                        lm-text-style [textStyle]="item?.textStyle"
                  >
                    <svg soho-icon *ngIf="item.icon && item.icon.sohoIcon || item?.displayAsAlert?.icon"
                         class="icon {{item?.displayAsAlert?.color}}"
                         [icon]="item?.displayAsAlert?.icon ? item?.displayAsAlert?.icon : item.icon.icon"
                         [attr.title]="item.displayValue"
                         soho-tooltip [content]="item.displayValue" [placement]="'bottom'">
                    </svg>
                    <img *ngIf="item.icon && !item.icon.sohoIcon && !item?.displayAsAlert" class="icon" src="{{item.icon.iconUrl}}">{{item?.displayValue}}
                  </span>

                    <!-- is rich text-->
                    <span *ngIf="item.isField && !item.displayAsTag && !item.isFormText && item.isRichText && !item.displayAsRating"
                          class="lm-card-field"
                          lm-text-style [textStyle]="item?.textStyle"
                          [innerHTML]="item.displayValue | safe"
                    ></span>

                    <!-- process indicator -->
                    <div *ngIf="item.isProcessIndicator" class="process-indicator compact responsive has-labels">
                      <div class="display">
                        <div *ngFor="let data of item.processIndicatorDisplayData; index as i" class="step" id="step{{data.stepId}}">
                          <div class="lines">
                            <div class="indicator {{data.completionStatusInfo.indicatorClass}}" [ngClass]="{'icon': data.completionStatusInfo.iconInfo.icon}" soho-tooltip content="{{data | lmProcessIndicatorTooltip}}">
                              <svg *ngIf="data.completionStatusInfo.iconInfo.icon" soho-icon icon="{{data.completionStatusInfo.iconInfo.icon}}" class="{{data.completionStatusInfo.iconInfo.colorClass}}"></svg>
                            </div>
                            <span class="separator" [ngClass]="{'darker': (data.status === 'C' || data.status === 'X')}"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- form button -->
                    <div *ngIf="item.isFormButton">
                      <button class="lm-form-button hyperlink" lm-field-style [fieldStyle]="item?.fieldStyle"
                        [attr.data-action-reference]="stringifyJson(item.cardButton?.actionReference)"
                        (click)="onActionClicked($event)"
                      >
                        <svg *ngIf="item.cardButton.icon" soho-icon [icon]="item.cardButton.icon" [extraIconClass]="'text-link'"></svg>
                        {{item.cardButton.actionReference?.label}}
                      </button>
                    </div>
                  </ng-container>

                  <!-- with alert -->
                  <label *ngIf="item.alertCondition" class="lm-card-field lm-card-alert " lm-field-style [fieldStyle]="item?.fieldStyle">
                    <svg soho-icon [icon]="item.alertCondition.icon" [attr.class]="alertClass(item)" [attr.title]="item.alertCondition.alertTooltip" soho-tooltip [content]="item.alertCondition.alertTooltip" [placement]="'bottom'"></svg>
                    {{item?.displayValue}}
                  </label>

                  <!-- display as progress bar -->
                  <lm-simple-progress *ngIf="item?.progressFieldData" [lmProgressFieldData]="item.progressFieldData" class="lm-card-field lm-font-md"></lm-simple-progress>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div *ngIf="cardTemplateData?.buttonMenu?.length > 0" class="lm-card-button-menu-container">
        <button class="btn-actions"
                type="button"
                attr.data-automation-id="{{cardTemplateData.automationId}}-button-menu-button"
                soho-context-menu [lazyLoad]="true" [trigger]="'click'" menu="lm-list-view-card-button-menu-{{dataView.id - 1}}"
                (click)="onButtonMenu()"
        >
          <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
            <use href="#icon-more"></use>
          </svg>
          <span class="audible" data-translate="text">More</span>
        </button>
      </div>
    </div>

    <!-- BUTTON ROW -->
    <div *ngIf="cardTemplateData?.buttonRow?.length > 0" class="lm-card-button-row lm-align-{{cardTemplateData.buttonRowAlignment}}">
      <ng-container *ngFor="let b of cardTemplateData.buttonRow">
        <!-- icon only -->
        <ng-container *ngIf="b.isIconOnly; else NotIconButton">
          <button
            *ngIf="b.isIconOnly"
            attr.data-automation-id="{{b?.automationId}}"
            soho-button="icon" [isToggle]="b?.isToggle" [isTogglePressed]="b.state?.isPressed" [icon]="b.icon"
            soho-tooltip [title]="b.displayTooltip ? b.actionReference?.label || b.actionReference?.tooltip : null"
            class="btn lm-icon-button"
            lm-field-style [fieldStyle]="b?.fieldStyle"
            [attr.data-action-reference]="stringifyJson(b?.actionReference)"
            [ngClass]="{'lm-missing-soho-icon': !b.icon}"
            (click)="onActionClicked($event)"
          >
            <span *ngIf="b.icon">{{b.actionReference?.label}}</span>
            <ng-container>
              <!-- Need nbsp, if span is empty then ids-enterprise css will hide it -->
              <span *ngIf="!b.icon" [ngStyle]="{'background-image': 'url(' + b.iconUrl + ')'}">&nbsp;</span>
              <span class="audible">{{b.actionReference?.label}}</span>
            </ng-container>
          </button>
        </ng-container>
        <ng-template #NotIconButton>
          <!-- httpUrl (external link)-->
          <a *ngIf="b.isOpenExternal"
             [ngClass]="{'btn hyperlink': b.isDisplayAsLink, 'btn': !b.isDisplayAsLink}"
             attr.data-automation-id="{{b?.automationId}}"
             [attr.href]="b.httpUrl"
             target="_blank"
             (click)="external(b, $event)"
          >
            <span>{{b.actionReference?.label}}</span>
          </a>

          <!-- display buttons as links -->
          <button *ngIf="b.isDisplayAsLink && !b.isOpenExternal"
            class="btn hyperlink"
            attr.data-automation-id="{{b?.automationId}}"
            lm-field-style [fieldStyle]="b?.fieldStyle"
            [attr.data-action-reference]="stringifyJson(b?.actionReference)"
            (click)="onActionClicked($event)"
          >
            <span>{{b.actionReference?.label}}</span>
          </button>

          <!-- action buttons -->
          <button *ngIf="!b.isDisplayAsLink && !b.isOpenExternal"
            class="btn"
            [ngClass]="{'lm-is-primary': b?.isPrimary}"
            attr.data-automation-id="{{b?.automationId}}"
            lm-field-style [fieldStyle]="b?.fieldStyle"
            [attr.data-action-reference]="stringifyJson(b?.actionReference)"
            (click)="onActionClicked($event)"
          >
            <span>{{b.actionReference?.label}}</span>
          </button>
        </ng-template>
      </ng-container>
    </div>
  </div>

</ng-template>

<ng-template #DoesNotExist>
  <del>
    <ng-container [ngTemplateOutlet]= "CardContent"></ng-container>
  </del>
</ng-template>

<ng-template #NoData>
  <p>{{noDataAvailable}}</p>
</ng-template>

